function getLocalBackendPort(): number {
  const configured = Number(import.meta.env.VITE_APP_LOCAL_BACKEND_PORT);
  return Number.isInteger(configured) && configured > 0 ? configured : 8084;
}

function getLocalCdnPort(): number {
  const configured = Number(import.meta.env.VITE_APP_LOCAL_CDN_PORT);
  return Number.isInteger(configured) && configured > 0 ? configured : 8085;
}

function isLocalhost(hostname: string): boolean {
  return hostname === "localhost" || hostname === "127.0.0.1";
}

function getBackendDomain(): string {
  const { hostname } = window.location;
  if (isLocalhost(hostname)) {
    return `http://localhost:${getLocalBackendPort()}`;
  }
  const backendDomain = import.meta.env.VITE_BACKEND_DOMAIN;
  if (!backendDomain) {
    throw new Error("Missing VITE_BACKEND_DOMAIN configuration");
  }
  return `https://api.${backendDomain}`;
}

function getCdnDomain(): string {
  const { hostname } = window.location;
  if (isLocalhost(hostname)) {
    return `http://localhost:${getLocalCdnPort()}`;
  }
  const backendDomain = import.meta.env.VITE_BACKEND_DOMAIN;
  if (!backendDomain) {
    throw new Error("Missing VITE_BACKEND_DOMAIN configuration");
  }
  return `https://cdn.${backendDomain}`;
}

export const BACKEND_DOMAIN = getBackendDomain();
export const CDN_DOMAIN = getCdnDomain();
